/**
 * A imagem de uma foto do posto. O arquivo só sai pelo download autenticado, então a tela o baixa como blob,
 * mostra por um endereço temporário e o revoga ao desmontar (ou quando a foto muda).
 */
import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { ergonomicWorkstationService } from '../../../../../services/ergonomicWorkstationService';

interface PhotoImageProps {
  workstationId: number;
  photoId: number;
  alt: string;
}

type ImageState = { status: 'loading' } | { status: 'error' } | { status: 'ready'; url: string };

export const PhotoImage: React.FC<PhotoImageProps> = ({ workstationId, photoId, alt }) => {
  const [state, setState] = useState<ImageState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    let objectUrl: string | null = null;
    ergonomicWorkstationService
      .downloadPhoto(workstationId, photoId)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setState({ status: 'ready', url: objectUrl });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [workstationId, photoId]);

  return (
    <Box
      sx={{
        aspectRatio: '4 / 3',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.100',
        borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      {state.status === 'loading' && (
        <Box role="status" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CircularProgress size={20} />
          <Typography variant="body1">Carregando a foto…</Typography>
        </Box>
      )}
      {state.status === 'error' && (
        <Typography variant="body1" sx={{ p: 2, textAlign: 'center' }}>
          Não foi possível mostrar esta foto.
        </Typography>
      )}
      {state.status === 'ready' && (
        <Box component="img" src={state.url} alt={alt} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      )}
    </Box>
  );
};
